import { Input } from "../../inputs/Input";
import { Label } from "../../Label";
import { Separator } from "../../Separator";

export interface NumberRangeFilter {
  type: "numberRange";
  min: number | null;
  max: number | null;
}

interface NumberRangeFilterInputProps {
  value: NumberRangeFilter | undefined;
  onChange: (value: NumberRangeFilter | undefined) => void;
}

export function NumberRangeFilterInput({
  value,
  onChange,
}: NumberRangeFilterInputProps) {
  const min = value?.min ?? null;
  const max = value?.max ?? null;

  const emit = (newMin: number | null, newMax: number | null) => {
    if (newMin === null && newMax === null) {
      onChange(undefined);
    } else {
      onChange({ type: "numberRange", min: newMin, max: newMax });
    }
  };

  return (
    <div className="flex items-end gap-2">
      <div className="flex flex-col gap-1">
        <Label className="text-xs font-medium text-gray-600">Min</Label>
        <Input
          type="number"
          size="sm"
          placeholder="Min"
          value={min ?? ""}
          onChange={(e) => {
            const parsed =
              e.target.value === "" ? null : Number(e.target.value);
            emit(parsed, max);
          }}
        />
      </div>
      <div className="pb-1.5">
        <Separator orientation="vertical" className="h-6" />
      </div>
      <div className="flex flex-col gap-1">
        <Label className="text-xs font-medium text-gray-600">Max</Label>
        <Input
          type="number"
          size="sm"
          placeholder="Max"
          value={max ?? ""}
          onChange={(e) => {
            const parsed =
              e.target.value === "" ? null : Number(e.target.value);
            emit(min, parsed);
          }}
        />
      </div>
    </div>
  );
}
